import script from "./recordList.vue?vue&type=script&setup=true&lang=js"
export * from "./recordList.vue?vue&type=script&setup=true&lang=js"

import "./recordList.vue?vue&type=style&index=0&id=6e06e59a&lang=scss&scoped=true"

import exportComponent from "/Users/zhuweiyun/Desktop/zwy/vue3-天空之城/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e06e59a"]])

export default __exports__